<ng-container [ngSwitch]="block.type">
    <app-asset [theme]="theme" [block]="block" *ngSwitchCase="'assetComponent'"></app-asset>
    <app-list [theme]="theme" [block]="block" *ngSwitchCase="'checkedRepeaterComponent'"></app-list>
    <app-review [theme]="theme" [block]="block" *ngSwitchCase="'review'"></app-review>
    <app-boxed [theme]="theme" [block]="block" *ngSwitchCase="'boxedContentComponent'"></app-boxed>
    <app-wysiwyg [theme]="theme" [block]="block" *ngSwitchCase="'contentComponent'"></app-wysiwyg>
    <app-wysiwyg [theme]="theme" [block]="block" *ngSwitchCase="'contentLimitedComponent'"></app-wysiwyg>
    <app-newsletter [theme]="theme" [block]="block" *ngSwitchCase="'newsletter'"></app-newsletter>
</ng-container>
